<p-dialog
  #loadingModal
  [modal]="true"
  [showHeader]="false"
  [closeOnEscape]="false"
  [resizable]="false"
  [breakpoints]="{ '450px': '100vw' }"
  [(visible)]="display"
  styleClass="modal-loading"
  contentStyleClass="modal-loading-content"
>
  <div class="lds-css ng-scope">
    <div style="width: 100%; height: 100%" class="lds-rolling">
      <div></div>
    </div>
  </div>
</p-dialog>
